<template>
    <div class="coupon">
        <!-- 选项卡 -->
        <div class="flex__around__center nav">
            <div class="flex align-center nav__item" :class="loads.index==index?'active':''" v-for="(item,index) in nav_list" :key="index" @click="loads.index=index">
                <span class="fs_32" :class="loads.index==index?'c_1a fw_500':'c_80'">{{item.text}}</span>
            </div>
        </div>
        <!-- 数据列表 -->
        <div class="list">
            <div class="flex item" v-for="item in list" :key="item.id" @click="receive(index)">
                <img src="@/assets/images/coupon.png" alt="">
                <div class="flex item__left">
                    <div class="flex__center__around item__left__left">
                        <span class="fs_50 c_main"><span class="fs_24">¥</span>{{item.price}}</span>
                        <span class="fs_20 c_main">满{{item.coupon_limit}}元可用</span>
                    </div>
                    <div class="flex__null__around item__left__right">
                        <span class="fs_30 c_1a ellipsis_one">{{item.name}}</span>
                        <span class="fs_22 c_80 ellipsis_one">{{item.brief}}</span>
                        <span class="fs_20 c_80">{{item.start_time}}~{{item.end_time}}</span>
                    </div>
                </div>
                <div class="flex__center__center item__right">
                    <span class="fs_22 c_ff lh_30" v-if="loads.index==0">使用</span>
                    <span class="fs_22 c_ff lh_30" v-if="loads.index==1">已用</span>
                    <span class="fs_22 c_ff lh_30" v-if="loads.index==2">过期</span>
                </div>
                <div class="layer" v-if="loads.index==2"></div>
            </div>
        </div>
        <!-- 底部按钮 -->
        <div class="flex__center__center footer" v-link="'/Coupon/Receive'">
            <span class="fs_32 c_66">去领券中心</span>
        </div>
        <jc-list :url="'/Coupon/getMyCouponList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name:"Coupon",
    data(){
        return{
            list: [],
            loads:{
                user_id: localStorage.user_id,
                index: 0,
                page:1 
            },
            nav_list:[
                {
                    text:'未使用',
                    status: 0
                },
                {
                    text:'已使用',
                    status: 1
                },
                {
                    text:'已过期',
                    status: 2
                }
            ]
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        }
    }
}
</script>
<style scoped>
.nav{
    height: 90px;
    background: #fff;
}
.nav__item.active{
    height: 90px;
    border-bottom: 4px solid #F93A42;
}
.list{
    padding: 0 30px;
}
.item{
    position: relative;
    height: 160px;
    margin-top: 30px;
    border-radius: 10px;
    box-shadow:0px 0px 10px 0px rgba(230,230,230,1);
}
.item img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.item .layer{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: 0.5;
}
.item__left{
    position: absolute;
    left: 0;
    width: 610px;
    height: 160px;
    padding: 20px 0;
}
.item__left__left{
    width: 160px;
    border-right: 2px dashed #e6e6e6;
}
.item__left__right{
    width: 420px;
    margin-left: 30px;
}
.item__right{
    position: absolute;
    right: 0;
    width: 80px;
    height: 160px;
}
.footer{
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 98px;
    background: #fff;
}
</style>





// WEBPACK FOOTER //
// src/pages/coupon/Index.vue